export var OneOnOneStage;
(function (OneOnOneStage) {
    OneOnOneStage["GOALS_REVIEW"] = "goals-review";
})(OneOnOneStage || (OneOnOneStage = {}));
// Manager can access the one-on-one only after all these stages are completed
export const REQUIRED_STAGES_FOR_MANAGER_ACCESS = [
    OneOnOneStage.GOALS_REVIEW,
];
